export default __webpack_public_path__ + "icon37255d3.svg";